<div class="report-chart-card d-flex flex-column">
  <div class="chart-card-header">
    <span class="chart-card-title">{{ titleKey() | translate }}</span>
  </div>
  <div class="chart-card-body">
    @if (hasData()) {
      <div echarts class="chart-canvas" [options]="options()!" (chartClick)="onChartClick($event)"></div>
    } @else {
      <div class="chart-empty d-flex flex-column align-items-center justify-content-center">
        <mat-icon>bar_chart</mat-icon>
        <span>{{ 'app.reports.dashboard.chart_empty' | translate }}</span>
      </div>
    }
  </div>
</div>
